import React, { useState, useRef, useEffect, useMemo } from "react";
import { httpClient } from '../../../HttpClient';
import { useEtatGlobal } from "../../EtatGlobal.js";
import "../Suivi.css";
import { IoIosSearch } from "react-icons/io";
import { CiFilter } from "react-icons/ci";
import CreateTodo from "./JuridiquePonctuelle/createTodo.js";
import FicheClientOverlay from "../../Portefeuille/FicheClientOverlay";
import { missionCommencee, missionActive, estBloque, classeLigneBloquee } from "./suiviProdUtils";
import BadgeBloque from "./BadgeBloque";
import { TbFileExport } from "react-icons/tb";
import { GoPencil } from "react-icons/go";
import { AiOutlineDelete } from "react-icons/ai";

import {
  Building2,
  CheckSquare,
  X,
  AlertCircle,
  FileText,
  ChartSpline,
} from "lucide-react";

import { dialog } from "../../../components/ui/Dialog";
function SuiviSocial({ suivi, loading, refetch }) {
  const [selectedYear, setSelectedYear] = useState(null);
  const [initialFormData, setInitialFormData] = useState({});
  const [showCreateTodo, setShowCreateTodo] = useState(false); // nouvel état

  const [searchTerm, setSearchTerm] = useState("");
  const [filterRows, setFilterRows] = useState([
    { column: "collaborateur", selectedValues: [] },
  ]);
  const [showFilterOverlay, setShowFilterOverlay] = useState(false);

  const [showExportOverlay, setShowExportOverlay] = useState(false);
  const [exportYear, setExportYear] = useState(
    selectedYear || new Date().getFullYear()
  );
  const [exportMonth, setExportMonth] = useState(new Date().getMonth() + 1);

  const [showAddModal, setShowAddModal] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [currentTable, setCurrentTable] = useState("");
  const [isLoadModif, setIsLoadModif] = useState(false);
  const [localSuiviCache, setLocalSuiviCache] = useState({});
  const [isGenerating, setIsGenerating] = useState(false);

  const [openedEventId, setOpenedEventId] = useState(null);

  const moisOptions = [
    { value: 1, label: "Janvier" },
    { value: 2, label: "Février" },
    { value: 3, label: "Mars" },
    { value: 4, label: "Avril" },
    { value: 5, label: "Mai" },
    { value: 6, label: "Juin" },
    { value: 7, label: "Juillet" },
    { value: 8, label: "Août" },
    { value: 9, label: "Septembre" },
    { value: 10, label: "Octobre" },
    { value: 11, label: "Novembre" },
    { value: 12, label: "Décembre" },
  ];

  useEffect(() => {
    if (!loading) {
      setLocalSuiviCache({});
    }
  }, [suivi, loading]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (overlayRef.current && !overlayRef.current.contains(event.target)) {
        setShowFilterOverlay(false);
      }
    };
    if (showFilterOverlay) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showFilterOverlay]);

  // 🔹 Extraire les valeurs uniques pour filtres
  const uniqueValues = useMemo(() => {
    const values = {
      formeSociale: Array.from(new Set(suivi.flatMap((c) => c.formeSociale))),
      regimeFiscal: Array.from(new Set(suivi.map((c) => c.regimeFiscal))),
      regimeTVA: Array.from(new Set(suivi.map((c) => c.regimeTVA))),
      expertComptable: Array.from(new Set(suivi.map((c) => c.expertComptable))),
      superviseur: Array.from(new Set(suivi.map((c) => c.superviseur))),
      collaborateur: Array.from(new Set(suivi.map((c) => c.collaborateur))),
      missionComptable: Array.from(
        new Set(suivi.map((c) => c.missionComptable))
      ),
      missionSociale: Array.from(new Set(suivi.map((c) => c.missionSociale))),
      missionJuridique: Array.from(
        new Set(suivi.map((c) => c.missionJuridique))
      ),
      missionIR: Array.from(new Set(suivi.map((c) => c.missionIR))),
      groupement: Array.from(new Set(suivi.map((c) => c.groupement))),
      preparationBS: Array.from(
        new Set(suivi.flatMap((c) => c.suiviSocial.map((t) => t.preparationBS)))
      ),
      dsn: Array.from(
        new Set(suivi.flatMap((c) => c.suiviSocial.map((t) => t.dsn)))
      ),
    };
    return values;
  }, [suivi]);

  // Récupère la liste des années disponibles pour le SELECT
  const getAvailableYears = (clients) => {
    if (!clients || clients.length === 0) return [];

    // Récupération de toutes les années présentes dans suiviSocial
    let years = [];
    clients.forEach((client) => {
      const clotureYear = new Date(client.dateCloture).getFullYear();
      years.push(clotureYear);

      client.suiviSocial.forEach((tva) => {
        years.push(tva.annees);
      });
    });

    // On garde unique et trié
    years = [...new Set(years)].sort((a, b) => a - b);

    // Ajout de l'année suivante
    const maxYear = Math.max(...years);
    years.push(maxYear + 1);

    return years;
  };

  const availableYears = getAvailableYears(suivi);

  // Si pas encore sélectionné, mettre la première année comme par défaut
  useEffect(() => {
    if (availableYears.length > 0 && !selectedYear) {
      if (availableYears.includes(2026)) {
        setSelectedYear(2026);
      } else {
        setSelectedYear(Math.max(...availableYears)); // prend la plus grande année sinon
      }
    }
  }, [availableYears, selectedYear]);

  // Labels dynamiques avec année choisie
  const moisLabels = selectedYear
    ? Array.from({ length: 12 }, (_, i) => `${i + 1}/${selectedYear}`)
    : [];

  const [showDetailsOverlay, setShowDetailsOverlay] = useState(false);
  const [currentDetails, setCurrentDetails] = useState({});
  const [selectedClient, setSelectedClient] = useState({});

  // Fiche client partagée (mêmes états que SuiviJuridiqueAGO / SuiviBilan)
  const [ficheClientOpen, setFicheClientOpen] = useState(false);
  const [ficheClientData, setFicheClientData] = useState(null);
  const [ficheClientLoading, setFicheClientLoading] = useState(false);
  const ficheClientCache = useRef({});
  const [formData, setFormData] = useState({
    preparationBS: "",
    nombreBS: "",
    preparationBSDate: null,
    dsn: "",
    dsnDate: null,
    commentaire: "",

    AttestationAT: [],
    DSNMaladieAT: [],
    AttestationMaternitePaternite: [],
    ChomagePartielle: [],

    Dpae: [],
    ContratDetravail: [],
    Avenant: [],

    CertiicatTravail: [],
    AttestationPole: [],
    RecuSolde: [],
    RuptureConventionnelle: [],
    Licenciement: [],
    Demission: [],
    FinPeriodedEssai: [],
    FinContratPro: [],
    FinContratApprenti: [],
    RuptureCommun: [],
    FinCdd: [],

    CourriersDivers: [],
  });

  const { utilisateur } = useEtatGlobal();

  const userComplet = `${utilisateur.lastName} ${utilisateur.name}`;

  const overlayRef = useRef(null);

  const showClientDetails = async (client) => {
    setFicheClientOpen(true);
    if (ficheClientCache.current[client.id]) {
      setFicheClientData(ficheClientCache.current[client.id]);
      setFicheClientLoading(false);
      return;
    }
    setFicheClientData(client);
    setFicheClientLoading(true);
    try {
      const { data } = await httpClient.get(
        `https://backend-myalfa.vercel.app/api/clients/${client.id}`
      );
      ficheClientCache.current[client.id] = data;
      setFicheClientData(data);
    } catch (err) {
      console.error("Erreur chargement client:", err);
    } finally {
      setFicheClientLoading(false);
    }
  };

  const handleCellClick = (client, mois) => {
    const key = `${client.id}-${selectedYear}-${mois}`;
    const record =
      localSuiviCache[key] ||
      client.suiviSocial.find(
        (entry) => entry.mois === mois && entry.annees === selectedYear
      );

    const data = record
      ? {
          preparationBS: record.preparationBS || "",
          nombreBS: record.nombreBS || "",
          preparationBSDate: record.preparationBSDate || null,
          preparationBSUser: record.preparationBSUser || "",
          dsn: record.dsn || "",
          dsnDate: record.dsnDate || null,
          dsnUser: record.dsnUser || "",
          commentaire: record.commentaire || "",

          AttestationAT: record.AttestationAT || [],
          DSNMaladieAT: record.DSNMaladieAT || [],
          AttestationMaternitePaternite:
            record.AttestationMaternitePaternite || [],
          ChomagePartielle: record.ChomagePartielle || [],

          Dpae: record.Dpae || [],
          ContratDetravail: record.ContratDetravail || [],
          Avenant: record.Avenant || [],

          CertiicatTravail: record.CertiicatTravail || [],
          AttestationPole: record.AttestationPole || [],
          RecuSolde: record.RecuSolde || [],
          RuptureConventionnelle: record.RuptureConventionnelle || [],
          Licenciement: record.Licenciement || [],
          Demission: record.Demission || [],
          FinPeriodedEssai: record.FinPeriodedEssai || [],
          FinContratPro: record.FinContratPro || [],
          FinContratApprenti: record.FinContratApprenti || [],
          RuptureCommun: record.RuptureCommun || [],
          FinCdd: record.FinCdd || [],

          CourriersDivers: record.CourriersDivers || [],
        }
      : {
          preparationBS: "",
          nombreBS: "",
          preparationBSDate: null,
          preparationBSUser: "",
          dsn: "",
          dsnDate: null,
          dsnUser: "",
          commentaire: "",

          AttestationAT: [],
          DSNMaladieAT: [],
          AttestationMaternitePaternite: [],
          ChomagePartielle: [],

          Dpae: [],
          ContratDetravail: [],
          Avenant: [],

          CertiicatTravail: [],
          AttestationPole: [],
          RecuSolde: [],
          RuptureConventionnelle: [],
          Licenciement: [],
          Demission: [],
          FinPeriodedEssai: [],
          FinContratPro: [],
          FinContratApprenti: [],
          RuptureCommun: [],
          FinCdd: [],

          CourriersDivers: [],
        };

    setFormData(data);
    setInitialFormData(data); // 🔹 sauvegarde initiale
    setCurrentDetails(record || { mois, annees: selectedYear });
    setSelectedClient(client);
    setShowDetailsOverlay(true);
  };

  const handleSubmit = async () => {
    try {
      await httpClient.put(
        `https://backend-myalfa.vercel.app/api/suiviSocial/${currentDetails.annees}/${currentDetails.mois}/${selectedClient.id}`,
        formData
      );
    } catch (error) {
      console.error("Erreur lors de l'envoi du formulaire :", error);
      dialog.alert("Une erreur est survenue.");
    }
  };

  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("fr-FR");
  };

  const renderField = (label, value) => (
    <p>
      <strong>{label} :</strong> {value || "-"}
    </p>
  );

  const formatDateTime = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (loading) {
    return (
      <div>
        <div className="flex items-center justify-between gap-4 mb-5 mt-8">
          <div className="h-9 w-64 rounded-md bg-slate-200 animate-pulse" />
          <div className="flex items-center gap-5">
            <div className="h-9 w-20 rounded-md bg-slate-200 animate-pulse" />
            <div className="h-9 w-20 rounded-md bg-slate-200 animate-pulse" />
          </div>
        </div>
        <div className="w-full overflow-x-auto border border-slate-200 rounded-lg shadow-sm">
          <table className="text-sm w-full" style={{ minWidth: "900px" }}>
            <thead>
              <tr className="bg-[#6e1a36]">
                <th className="px-4 py-2">
                  <div className="h-3 rounded bg-[#ffffff33] animate-pulse w-16" />
                </th>
                {["Jan", "Fév", "Mar", "Avr", "Mai", "Jun", "Jul", "Aoû", "Sep", "Oct", "Nov", "Déc"].map((m, i) => (
                  <th key={i} className="px-3 py-2">
                    <div className="h-3 rounded bg-[#ffffff33] animate-pulse w-8 mx-auto" />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200">
              {Array.from({ length: 8 }).map((_, i) => (
                <tr key={i}>
                  <td className="px-4 py-2">
                    <div className="h-3 rounded bg-slate-200 animate-pulse w-32" />
                  </td>
                  {Array.from({ length: 12 }).map((__, j) => (
                    <td key={j} className="px-3 py-2 text-center">
                      <div className="h-6 rounded-md bg-slate-200 animate-pulse mx-auto w-8" />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  // 🔹 Gestion filtres dynamiques
  const handleAddFilter = () => {
    setFilterRows((prev) => [
      ...prev,
      { column: "collaborateur", selectedValues: [] },
    ]);
  };

  const handleRemoveFilter = (indexToRemove) => {
    setFilterRows((prev) => prev.filter((_, i) => i !== indexToRemove));
  };

  const handleFilterChange = (index, field, value) => {
    setFilterRows((prev) =>
      prev.map((f, i) =>
        i === index ? { ...f, [field]: value, selectedValues: [] } : f
      )
    );
  };

  const handleCheckboxValueChange = (index, value) => {
    setFilterRows((prev) =>
      prev.map((f, i) => {
        if (i !== index) return f;
        const selectedValues = f.selectedValues || [];
        const updated = selectedValues.includes(value)
          ? selectedValues.filter((v) => v !== value)
          : [...selectedValues, value];
        return { ...f, selectedValues: updated };
      })
    );
  };

  const handleResetFilters = () => {
    setFilterRows([{ column: "collaborateur", selectedValues: [] }]);
    setSearchTerm("");
  };

  // 🔹 Appliquer les filtres et recherche
  const filteredData = suivi.filter((client) => {
    const matchesSearch = client.nom
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchesFilters = filterRows.every((filter) => {
      if (!filter.selectedValues || filter.selectedValues.length === 0)
        return true;
      if (["preparationBS", "dsn"].includes(filter.column)) {
        return client.suiviSocial.some((t) => {
          const matchValeur = filter.selectedValues.includes(t[filter.column]);
          const matchMois =
            !filter.selectedMonth ||
            Number(t.mois) === Number(filter.selectedMonth);
          return matchValeur && matchMois;
        });
      }

      return filter.selectedValues.includes(client[filter.column]);
    });
    // Mission pas encore débutée cette année-là → masqué ; client archivé
    // depuis une année antérieure → masqué aussi.
    const missionDebutee =
      !selectedYear ||
      (missionCommencee(client, selectedYear) &&
        missionActive(client, selectedYear));
    return matchesSearch && matchesFilters && missionDebutee;
  });

  const handleCloseOverlay = async () => {
    const hasChanged =
      JSON.stringify(formData) !== JSON.stringify(initialFormData);

    setShowCreateTodo(false);
    setShowDetailsOverlay(false); // ✅ on ferme immédiatement
    setIsLoadModif(true);

    if (hasChanged) {
      const key = `${selectedClient.id}-${currentDetails.annees}-${currentDetails.mois}`;

      // ✅ 1. Mise à jour immédiate dans le cache local
      setLocalSuiviCache((prev) => ({
        ...prev,
        [key]: {
          ...formData,
          mois: currentDetails.mois,
          annees: currentDetails.annees,
        },
      }));

      // ✅ 2. Envoi serveur en arrière-plan
      handleSubmit()
        .then(() => refetch())
        .finally(() => setIsLoadModif(false));
    } else {
      setIsLoadModif(false);
    }
  };

  const itemtype = "SuiviSocial"; // Assurez-vous que l'item a un type

  const allEmpty =
    formData.AttestationAT.length === 0 &&
    formData.DSNMaladieAT.length === 0 &&
    formData.AttestationMaternitePaternite.length === 0 &&
    formData.ChomagePartielle.length === 0 &&
    formData.Dpae.length === 0 &&
    formData.ContratDetravail.length === 0 &&
    formData.Avenant.length === 0 &&
    formData.CertiicatTravail.length === 0 &&
    formData.AttestationPole.length === 0 &&
    formData.RecuSolde.length === 0 &&
    formData.RuptureConventionnelle.length === 0 &&
    formData.Licenciement.length === 0 &&
    formData.Demission.length === 0 &&
    formData.FinPeriodedEssai.length === 0 &&
    formData.FinContratPro.length === 0 &&
    formData.FinContratApprenti.length === 0 &&
    formData.RuptureCommun.length === 0 &&
    formData.FinCdd.length === 0 &&
    formData.CourriersDivers.length === 0;

  const tableLabels = {
    AttestationAT: "Attestation papier AT",
    DSNMaladieAT: "DSN Maladie ou AT",
    AttestationMaternitePaternite: "Attestation maternité / paternité",
    ChomagePartielle: "Chômage partielle",
    Dpae: "DPAE",
    ContratDetravail: "Contrat de travail",
    Avenant: "Avenant",
    CertiicatTravail: "Certificat de travail",
    AttestationPole: "Attestation Pôle Emploi",
    RecuSolde: "Reçu pour solde de tout compte",
    RuptureConventionnelle: "Rupture conventionnelle",
    Licenciement: "Licenciement",
    Demission: "Démission",
    FinPeriodedEssai: "Fin période d'essai",
    FinContratPro: "Fin contrat de pro",
    FinContratApprenti: "Fin contrat d'apprenti",
    RuptureCommun: "Rupture commun",
    FinCdd: "Fin CDD",
    CourriersDivers: "Courriers divers",
  };

  return (
    <div>
      <div className="flex items-center justify-between gap-4 mb-5 mt-8">
        <div className="relative flex-1 max-w-sm">
          <IoIosSearch className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <input
            type="text"
            placeholder="Rechercher ..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-9 h-9 w-full rounded-md bg-slate-50 border border-slate-200 text-sm focus:bg-white focus:outline-none"
          />
        </div>

        <div className="flex items-center gap-5">
          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(Number(e.target.value))}
            className="border border-slate-300 rounded-md 
                            h-9 px-2 text-xs leading-tight w-20
                            bg-white"
          >
            {availableYears.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>

          <button
            onClick={() => setShowFilterOverlay(!showFilterOverlay)}
            className={`flex items-center gap-2 h-9 px-3 rounded-md font-semibold text-sm bg-white text-black border border-slate-300 hover:bg-slate-50`}
          >
            <CiFilter className="w-3 h-3" />
            Filtrer
          </button>
          <button
            onClick={() => setShowExportOverlay(true)}
            className="flex items-center gap-2 h-9 px-4 rounded-md font-semibold text-white bg-slate-700 hover:bg-slate-800"
          >
            <TbFileExport className="w-3.5 h-3.5" />
            Exporter
          </button>
        </div>
        {showFilterOverlay && (
          <div
            ref={overlayRef}
            className="absolute top-52 right-0 -translate-x-1/2 bg-white border border-slate-200 rounded-lg p-4 shadow-lg z-50 w-2/5"
          >
            <div className="flex justify-between mb-2">
              <p className="font-semibold">Filtres avancés</p>
              <button
                className="text-sm text-slate-600 hover:text-slate-800"
                onClick={handleResetFilters}
              >
                Réinitialiser
              </button>
            </div>
            {filterRows.map((filter, index) => (
              <div key={index} className="mb-3">
                <div className="flex items-center justify-between mb-1">
                  {["preparationBS", "dsn"].includes(filter.column) && (
                    <select
                      className="border border-slate-200 rounded-md p-1 text-sm"
                      value={filter.selectedMonth || ""}
                      onChange={(e) =>
                        handleFilterChange(
                          index,
                          "selectedMonth",
                          e.target.value
                        )
                      }
                    >
                      <option value="">Tous les mois</option>
                      {moisOptions.map((mois) => (
                        <option key={mois.value} value={mois.value}>
                          {mois.label}
                        </option>
                      ))}
                    </select>
                  )}
                  <select
                    className="border border-slate-200 rounded-md p-1 text-sm"
                    value={filter.column}
                    onChange={(e) =>
                      handleFilterChange(index, "column", e.target.value)
                    }
                  >
                    {Object.keys(uniqueValues).map((col) => (
                      <option key={col} value={col}>
                        {col}
                      </option>
                    ))}
                  </select>

                  <button
                    className="text-sm text-red-600 hover:text-red-800"
                    onClick={() => handleRemoveFilter(index)}
                  ></button>
                </div>
                <div className="flex flex-col ml-2">
                  {(["preparationBS", "dsn"].includes(filter.column)
                    ? ["oui"] // 👉 on ne montre que "oui" pour ces deux filtres
                    : uniqueValues[filter.column] || []
                  ).map((value) => (
                    <label key={value}>
                      <input
                        type="checkbox"
                        checked={filter.selectedValues.includes(value)}
                        onChange={() => handleCheckboxValueChange(index, value)}
                        className="mr-2"
                      />
                      {value || "(vide)"}
                    </label>
                  ))}
                </div>
              </div>
            ))}
            <button
              className="text-sm text-slate-700 hover:text-slate-900 mt-2"
              onClick={handleAddFilter}
            >
              + Ajouter filtre
            </button>
          </div>
        )}
        {showExportOverlay && (
          <div
            className="absolute top-52 right-0 -translate-x-1/2 
               bg-white border border-slate-200 
               rounded-lg p-4 shadow-lg z-50 w-80"
          >
            {/* Header */}
            <div className="flex justify-between items-center mb-4">
              <p className="font-semibold text-slate-800">
                Exporter Suivi Social
              </p>
              <button
                onClick={() => setShowExportOverlay(false)}
                className="text-sm text-slate-500 hover:text-slate-800"
                disabled={isGenerating}
              >
                ✕
              </button>
            </div>

            {/* Année */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-slate-600 mb-1">
                Année
              </label>
              <select
                value={exportYear}
                onChange={(e) => setExportYear(Number(e.target.value))}
                className="w-full h-9 rounded-md border border-slate-300 
                   bg-white px-2 text-sm focus:outline-none 
                   focus:ring-1 focus:ring-slate-400"
              >
                {availableYears.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            {/* Mois */}
            <div className="mb-5">
              <label className="block text-sm font-medium text-slate-600 mb-1">
                Mois
              </label>
              <select
                value={exportMonth}
                onChange={(e) => setExportMonth(Number(e.target.value))}
                className="w-full h-9 rounded-md border border-slate-300 
                   bg-white px-2 text-sm focus:outline-none 
                   focus:ring-1 focus:ring-slate-400"
              >
                {moisOptions.map((mois) => (
                  <option key={mois.value} value={mois.value}>
                    {mois.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Actions */}
            <div className="flex flex-col gap-2">
              <button
                onClick={async () => {
                  try {
                    setIsGenerating(true);
                    const url = `https://backend-myalfa.vercel.app/api/suiviSocial/export/${exportYear}/${exportMonth}`;
                    const response = await httpClient.get(url, {
                      responseType: "blob",
                    });
                    const blob = new Blob([response.data]);
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = `suivi_social_${exportYear}_${exportMonth}.xlsx`;
                    link.click();
                    setShowExportOverlay(false);
                  } catch (error) {
                    console.error("Erreur lors de l'export :", error);
                    dialog.alert("Erreur lors de l'export.");
                  } finally {
                    setIsGenerating(false);
                  }
                }}
                disabled={isGenerating}
                className={`h-9 rounded-md font-semibold text-sm 
                    flex items-center justify-center
                    transition
                    ${
                      isGenerating
                        ? "bg-slate-400 text-white cursor-not-allowed"
                        : "bg-slate-700 text-white hover:bg-slate-800"
                    }`}
              >
                {isGenerating ? "En cours de génération..." : "Générer"}
              </button>

              <button
                onClick={() => setShowExportOverlay(false)}
                disabled={isGenerating}
                className="h-9 rounded-md font-medium text-sm 
                   border border-slate-300 
                   text-slate-700 bg-white 
                   hover:bg-slate-50 transition"
              >
                Annuler
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Cartes stats — mois courant */}
      {(() => {
        const statMois = new Date().getMonth() + 1;
        const clientsAffiches = filteredData.filter((client) => {
          if (!selectedYear) return true;
          const clotureYear = new Date(client.dateCloture).getFullYear();
          return selectedYear >= clotureYear;
        });
        const getRecord = (client) => {
          const key = `${client.id}-${selectedYear}-${statMois}`;
          return (
            localSuiviCache[key] ||
            client.suiviSocial.find(
              (e) => e.mois === statMois && e.annees === selectedYear
            )
          );
        };
        const bsFaits = clientsAffiches.filter(
          (c) => getRecord(c)?.preparationBS === "oui"
        ).length;
        const dsnFaites = clientsAffiches.filter(
          (c) => getRecord(c)?.dsn === "oui"
        ).length;
        const moisLabel = moisOptions[statMois - 1].label;
        return (
          <div className="grid grid-cols-2 gap-4 mt-5">
            <div className="bg-white rounded-xl p-5 border border-slate-100 shadow-sm flex items-center gap-4">
              <div className="w-10 h-10 bg-[#e5ebfa] rounded-lg flex items-center justify-center border border-slate-100">
                <ChartSpline className="text-[#2c4fa1] w-5 h-5 font-light" />
              </div>
              <div>
                <p className="text-xs text-[#8d7b83] mb-0.5 font-medium m-0">
                  BS préparés — {moisLabel} {selectedYear}
                </p>
                <div className="flex items-baseline gap-1.5">
                  <span className="text-2xl font-bold text-slate-900">
                    {bsFaits}
                  </span>
                  <span className="text-base text-slate-400 font-medium">
                    / {clientsAffiches.length}
                  </span>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-5 border border-slate-100 shadow-sm flex items-center gap-4">
              <div className="w-10 h-10 bg-[#fbe3e3] rounded-lg flex items-center justify-center border border-red-100">
                <AlertCircle className="w-5 h-5 text-[#ba4848]" />
              </div>
              <div>
                <p className="text-xs text-[#8d7b83] mb-0.5 font-medium m-0">
                  DSN manquantes — {moisLabel} {selectedYear}
                </p>
                <span className="text-2xl font-bold text-slate-900">
                  {clientsAffiches.length - dsnFaites}
                </span>
              </div>
            </div>
          </div>
        );
      })()}

      <div className="mt-6 bg-white rounded-xl border border-slate-100 shadow-sm overflow-hidden">
        <div
          className="overflow-y-auto"
          style={{ maxHeight: "calc(100vh - 360px)", minHeight: "420px" }}
        >
          <table
            className="w-full min-w-[1200px]"
            style={{ fontSize: "0.72rem" }}
          >
            <thead className="sticky top-0 z-10">
              <tr className="bg-[#6e1a36] text-xs">
                <th className="px-2 py-3.5 text-white font-semibold text-left">
                  Dossier
                </th>
                {moisLabels.map((m, i) => (
                  <th
                    className="px-2 py-3.5 text-white font-semibold text-center"
                    key={i}
                  >
                    {m}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {filteredData
                .filter((client) => {
                  if (!selectedYear) return true;
                  const clotureYear = new Date(
                    client.dateCloture
                  ).getFullYear();
                  return selectedYear >= clotureYear; // 🔹 on garde que les clients dont la clôture est <= année sélectionnée
                })
                .map((client) => (
                  <tr
                    key={client.id}
                    className={`hover:bg-slate-50/50 transition-colors ${classeLigneBloquee(client)}`}
                  >
                    <td
                      onClick={() => showClientDetails(client)}
                      className="px-2 py-2 font-medium text-slate-900 cursor-pointer hover:text-[#9B1B5D] transition-colors"
                    >
                      {client.nom}
                      {estBloque(client) && <BadgeBloque />}
                    </td>

                    {moisLabels.map((_, moisIndex) => {
                      const mois = moisIndex + 1;
                      const key = `${client.id}-${selectedYear}-${mois}`;
                      const record =
                        localSuiviCache[key] ||
                        client.suiviSocial.find(
                          (entry) =>
                            entry.mois === mois && entry.annees === selectedYear
                        );

                      const nombreBS = record?.nombreBS
                        ? parseInt(record.nombreBS, 10)
                        : 0;

                      const isDsn = record?.dsn === "oui";
                      const isEmpty = nombreBS === 0 && !isDsn;

                      return (
                        <td
                          key={mois}
                          onClick={() => handleCellClick(client, mois)}
                          className="px-2 py-1.5 text-center cursor-pointer"
                        >
                          <div
                            className={`
          transition-all duration-200
          px-3 py-0.5 rounded-md
          ${
            isDsn
              ? "bg-emerald-600 text-white hover:bg-emerald-700"
              : isEmpty
              ? "bg-slate-100 text-slate-400 border border-slate-200 hover:bg-slate-200"
              : "text-slate-700 hover:bg-slate-100"
          }
        `}
                          >
                            {nombreBS > 0 ? nombreBS : ""}
                          </div>
                        </td>
                      );
                    })}
                  </tr>
                ))}

              {filteredData.length === 0 && (
                <tr>
                  <td colSpan={13} className="text-center py-12">
                    <div className="flex justify-center items-center">
                      <div className="w-6 h-6 border-2 border-slate-300 border-t-slate-600 rounded-full animate-spin"></div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showDetailsOverlay && (
        <div className="overlayAC">
          <div className="inoverlayLead">
            {showCreateTodo ? (
              <CreateTodo
                onBack={() => setShowCreateTodo(false)}
                item={selectedClient}
                itemtype={itemtype}
                onClose={() => setShowDetailsOverlay(false)} // ✔ ici c’est une fonction
                fetchData={refetch}
              />
            ) : (
              <div
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  width: "95%",
                  margin: "0 auto",
                }}
              >
                {isLoadModif ? (
                  <p
                    style={{
                      marginBottom: "1%",
                      color: "#840040",
                      fontSize: "0.8rem",
                    }}
                  >
                    des modifications sont en cours dans la base de données ...
                  </p>
                ) : (
                  <p></p>
                )}
                <div className="bg-white border-b-4 border-[#8B1538] px-4 pb-6">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-6">
                      {/* Logo Cabinet */}
                      <img
                        src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6969eee7337849d9e1d7fcb4/2957c578c_LogoAlfa-PNG-SansCartouche.png"
                        alt="Alfa"
                        className="h-16 object-contain"
                      />
                      <div className="h-12 w-px bg-slate-200" />
                      <div>
                        <div className="flex items-center gap-2 mb-1">
                          <Building2 className="w-4 h-4 text-slate-500" />
                          <span className="text-xs font-medium text-slate-600 uppercase tracking-wide">
                            Mission Social
                          </span>
                        </div>
                        <h1 className="text-2xl font-bold text-slate-900">
                          {selectedClient.nom}
                        </h1>
                      </div>
                    </div>

                    <div className="flex items-center gap-2 justify-end">
                      <button
                        onClick={() => setShowCreateTodo(true)}
                        variant="outline"
                        className="
                  inline-flex items-center
                  px-3 py-1.5 text-sm font-medium
                  border border-[#8B1538]
                  text-[#8B1538]
                  rounded-md
                  hover:bg-[#8B1538]
                  hover:text-white
                  transition-colors
                "
                      >
                        <CheckSquare className="w-4 h-4 mr-2" />
                        ToDo
                      </button>
                      <button
                        aria-label="Fermer"
                        className="p-2 rounded-md text-gray-500 hover:text-gray-800 transition"
                        onClick={handleCloseOverlay}
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                </div>

                {/* Checkbox Déclaration */}
                <br />
                <div className="bg-gradient-to-br from-[#9B1B5D]/5 via-white to-transparent rounded-xl p-5 border-2 border-[#9B1B5D]/20">
                  {/* Titre */}
                  <h4 className="text-sm font-bold text-[#9B1B5D] mb-4 flex items-center gap-2">
                    <AlertCircle className="w-4 h-4" />
                    Informations essentielles
                  </h4>

                  <div
                    className="divSection"
                    style={{
                      marginBottom: "20px",
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    <label>
                      <input
                        type="checkbox"
                        checked={formData.preparationBS === "oui"}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            preparationBS: e.target.checked ? "oui" : "non",
                            preparationBSDate: e.target.checked
                              ? new Date()
                              : null,
                            preparationBSUser: e.target.checked
                              ? userComplet
                              : "",
                          })
                        }
                      />
                      &nbsp; &nbsp;Préparation BS
                    </label>
                    <span style={{ fontSize: "0.8em", color: "#555" }}>
                      {formatDateTime(formData.preparationBSDate)} &nbsp; -
                      &nbsp;
                      {formData.preparationBSUser}
                    </span>
                  </div>
                  <div className="flex items-center justify-between gap-4 mb-4">
                    <label>Nombre de BS :</label>
                    <input
                      type="number"
                      name="nombreBS"
                      placeholder="0"
                      min="0"
                      step="1"
                      value={formData.nombreBS || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        // On s’assure que ce soit bien un entier positif
                        if (value === "" || /^[0-9]+$/.test(value)) {
                          setFormData({
                            ...formData,
                            nombreBS: value,
                          });
                        }
                      }}
                      className="

                      w-1/2
                      h-11
                      rounded-md
                      bg-white
                      px-3
                      text-sm
                      outline-none
                      transition-all
                      border-2
                      border-slate-300
                      focus:border-emerald-400
                    "
                    />
                  </div>
                  <div
                    className="divSection"
                    style={{
                      marginBottom: "20px",
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    <label>
                      <input
                        type="checkbox"
                        checked={formData.dsn === "oui"}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            dsn: e.target.checked ? "oui" : "non",
                            dsnDate: e.target.checked ? new Date() : null,
                            dsnUser: e.target.checked ? userComplet : "",
                          })
                        }
                      />
                      &nbsp; &nbsp;DSN
                    </label>
                    <span style={{ fontSize: "0.8em", color: "#555" }}>
                      {formatDateTime(formData.dsnDate)} &nbsp; - &nbsp;
                      {formData.dsnUser}
                    </span>
                  </div>
                  <div className="mt-3">
                    <label className="text-sm font-medium text-slate-700 mb-1 block">
                      Remarques :
                    </label>
                    <textarea
                      value={formData.commentaire}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          commentaire: e.target.value,
                        })
                      }
                      rows={4}
                      className="w-full rounded-md border-2 border-slate-300 px-3 py-2 text-sm bg-white outline-none focus:border-emerald-400 transition-all"
                    />
                  </div>
                </div>
                <br />
                <div className="bg-slate-50 rounded-xl p-4 border border-slate-200 mt-4">
                  <div className="flex items-center justify-between gap-2 mb-4">
                    <label className="text-sm font-semibold flex items-center gap-2 mb-3">
                      <FileText className="w-4 h-4 text-slate-500" />
                      Table Social
                    </label>
                    <button
                      className={`
                  inline-flex items-center
                  px-3 py-1.5 text-xs font-medium
                  border border-[#8B1538]
                  rounded-md
                  transition-colors
text-[#8B1538] hover:bg-[#8B1538] hover:text-white
                `}
                      onClick={() => setShowAddModal(true)}
                    >
                      Ajouter des tables
                    </button>
                  </div>

                  {showAddModal && (
                    <div className="bg-white border border-slate-200 rounded-lg p-4 mb-6 space-y-4">
                      <h3 className="text-sm font-semibold text-slate-800">
                        Ajouter un élément
                      </h3>

                      {/* Select */}
                      <div className="space-y-1">
                        <label className="text-xs font-medium text-slate-600">
                          Choisir une table
                        </label>

                        <select
                          value={currentTable}
                          onChange={(e) => setCurrentTable(e.target.value)}
                          className="w-full h-9 rounded-md border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#8B1538]"
                        >
                          <option value="">-- Sélectionner --</option>

                          <optgroup label="EVENEMENTS">
                            <option value="AttestationAT">
                              Attestation AT
                            </option>
                            <option value="DSNMaladieAT">
                              DSN Maladie / AT
                            </option>
                            <option value="AttestationMaternitePaternite">
                              Attestation maternité / paternité
                            </option>
                            <option value="ChomagePartielle">
                              Chômage partielle
                            </option>
                          </optgroup>

                          <optgroup label="ENTREES">
                            <option value="Dpae">DPAE</option>
                            <option value="ContratDetravail">
                              Contrat de travail
                            </option>
                            <option value="Avenant">Avenant</option>
                          </optgroup>

                          <optgroup label="SORTIES">
                            <option value="CertiicatTravail">
                              Certificat de travail
                            </option>
                            <option value="AttestationPole">
                              Attestation Pôle Emploi
                            </option>
                            <option value="RecuSolde">Reçu de solde</option>
                            <option value="RuptureConventionnelle">
                              Rupture conventionnelle
                            </option>
                            <option value="Licenciement">Licenciement</option>
                            <option value="Demission">Démission</option>
                            <option value="FinPeriodedEssai">
                              Fin période d'essai
                            </option>
                            <option value="FinContratPro">
                              Fin contrat de professionnalisation
                            </option>
                            <option value="FinContratApprenti">
                              Fin contrat d'apprentissage
                            </option>
                            <option value="RuptureCommun">
                              Rupture d'un commun accord
                            </option>
                            <option value="FinCdd">Fin CDD</option>
                          </optgroup>

                          <optgroup label="AUTRES">
                            <option value="CourriersDivers">
                              Courriers divers
                            </option>
                          </optgroup>
                        </select>
                      </div>

                      {/* Commentaire */}
                      <div className="space-y-1">
                        <label className="text-xs font-medium text-slate-600">
                          Commentaire
                        </label>

                        <textarea
                          value={newComment}
                          disabled={currentTable === ""}
                          placeholder={
                            currentTable === ""
                              ? "Sélectionner une table avant d'écrire..."
                              : ""
                          }
                          onChange={(e) => setNewComment(e.target.value)}
                          rows={3}
                          className={`
            w-full rounded-md border px-3 py-2 text-sm resize-none
            focus:outline-none focus:ring-1
            ${
              currentTable === ""
                ? "bg-slate-100 border-slate-200 text-slate-400 cursor-not-allowed"
                : "bg-white border-slate-300 focus:ring-[#8B1538]"
            }
          `}
                        />
                      </div>

                      {/* Actions */}
                      <div className="flex justify-end gap-3 pt-2">
                        <button
                          disabled={currentTable === ""}
                          onClick={() => {
                            setFormData({
                              ...formData,
                              [currentTable]: [
                                ...formData[currentTable],
                                {
                                  id: null,
                                  commentaire: newComment,
                                  userName: userComplet,
                                },
                              ],
                            });
                            setShowAddModal(false);
                            setCurrentTable("");
                            setNewComment("");
                          }}
                          className={`
            px-4 py-1.5 text-xs font-medium rounded-md transition
            ${
              currentTable === ""
                ? "bg-slate-300 text-white cursor-not-allowed"
                : "bg-[#8B1538] text-white hover:bg-[#6e102c]"
            }
          `}
                        >
                          Valider
                        </button>

                        <button
                          onClick={() => {
                            setShowAddModal(false);
                            setCurrentTable("");
                          }}
                          className="px-4 py-1.5 text-xs font-medium rounded-md border border-slate-300 text-slate-700 hover:bg-slate-100 transition"
                        >
                          Annuler
                        </button>
                      </div>
                    </div>
                  )}

                  {allEmpty ? (
                    <p className="text-sm text-slate-500 italic mb-4">
                      Aucun élément pour ces tableaux.
                    </p>
                  ) : (
                    [
                      "AttestationAT",
                      "DSNMaladieAT",
                      "AttestationMaternitePaternite",
                      "ChomagePartielle",
                      "Dpae",
                      "ContratDetravail",
                      "Avenant",
                      "CertiicatTravail",
                      "AttestationPole",
                      "RecuSolde",
                      "RuptureConventionnelle",
                      "Licenciement",
                      "Demission",
                      "FinPeriodedEssai",
                      "FinContratPro",
                      "FinContratApprenti",
                      "RuptureCommun",
                      "FinCdd",
                      "CourriersDivers",
                    ].map(
                      (table) =>
                        formData[table].length > 0 && (
                          <div
                            key={table}
                            className="mb-6 bg-white border border-slate-200 rounded-lg p-4"
                          >
                            <h4 className="text-sm font-semibold text-slate-800 mb-3">
                              {tableLabels[table]}
                            </h4>

                            {formData[table].map((item, index) => (
                              <div
                                key={index}
                                className="flex justify-between items-center bg-slate-50 border border-slate-200 rounded-md px-3 py-2 mb-2"
                              >
                                <span className="text-sm text-slate-700">
                                  {item.commentaire}
                                  {item.userName && (
                                    <span className="ml-2 text-xs text-slate-500">
                                      - {item.userName}
                                    </span>
                                  )}
                                </span>

                                <div className="flex items-center gap-2">
                                  <button
                                    onClick={() => {
                                      const updated = prompt(
                                        "Modifier le commentaire :",
                                        item.commentaire
                                      );
                                      if (updated !== null) {
                                        const arr = [...formData[table]];
                                        arr[index] = {
                                          ...arr[index],
                                          commentaire: updated,
                                          userName: userComplet,
                                        };
                                        setFormData({
                                          ...formData,
                                          [table]: arr,
                                        });
                                      }
                                    }}
                                    className="p-2 rounded-md bg-[#8B1538] text-white hover:bg-[#6e102c] transition"
                                  >
                                    <GoPencil size={14} />
                                  </button>

                                  <button
                                    onClick={() => {
                                      const arr = [...formData[table]];
                                      arr.splice(index, 1);
                                      setFormData({
                                        ...formData,
                                        [table]: arr,
                                      });
                                    }}
                                    className="p-2 rounded-md bg-[#8B1538] text-white hover:bg-[#6e102c] transition"
                                  >
                                    <AiOutlineDelete size={14} />
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        )
                    )
                  )}
                </div>

                <div className="bg-white border border-slate-200 rounded-lg p-4 mt-6">
                  {/* Header */}
                  <div className="flex items-center gap-2 text-sm font-semibold text-slate-800 mb-4">
                    <div className="w-2 h-2 rounded-full bg-[#8B1538]"></div>
                    Historique Évènement
                  </div>

                  {selectedClient.historiques
                    ?.filter(
                      (hist) =>
                        hist.titre === "création d'évènement" &&
                        hist.eventId !== null &&
                        hist.evenement &&
                        hist.evenement.type === "Social" &&
                        hist.evenement.typeDate
                    )
                    .filter((hist) => {
                      const eventDate = new Date(hist.evenement.typeDate);
                      const eventMonth = eventDate.getMonth() + 1;
                      const eventYear = eventDate.getFullYear();

                      const [selectedMonth, selectedYearLabel] =
                        moisLabels[currentDetails.mois - 1].split("/");

                      return (
                        Number(selectedMonth) === eventMonth &&
                        Number(selectedYearLabel) === eventYear
                      );
                    })
                    .map((hist) => (
                      <div
                        key={hist.id}
                        className="relative pl-6 mb-6 border-l-2 border-slate-200"
                      >
                        {/* Pastille */}
                        <div className="absolute -left-[6px] top-1 w-3 h-3 rounded-full bg-[#8B1538] border-2 border-white"></div>

                        {/* Carte */}
                        <div className="bg-slate-50 border border-slate-200 rounded-lg p-4 shadow-sm">
                          {/* Ligne principale */}
                          <div className="flex justify-between items-start mb-2">
                            <p className="text-sm font-semibold text-slate-800">
                              {new Date(
                                hist.evenement.typeDate
                              ).toLocaleDateString("fr-FR")}
                            </p>

                            <button
                              onClick={() =>
                                setOpenedEventId(
                                  openedEventId === hist.id ? null : hist.id
                                )
                              }
                              className="text-xs font-medium text-blue-600 hover:text-blue-800 hover:underline transition"
                            >
                              {openedEventId === hist.id
                                ? "Fermer"
                                : "Consulter"}
                            </button>
                          </div>

                          {/* Note */}
                          <p className="text-sm text-slate-600 mb-2">
                            {hist.evenement.note || "Sans note"}
                          </p>

                          {/* Détails */}
                          {openedEventId === hist.id && (
                            <div className="mt-3 pt-3 border-t border-slate-200 space-y-2 text-sm text-slate-700">
                              {renderField("Note", hist.evenement.note)}
                              {renderField(
                                "Descriptif",
                                hist.evenement.descriptif
                              )}
                              {renderField(
                                "Catégorie",
                                hist.evenement.categorie
                              )}
                              {renderField(
                                "Téléphone",
                                hist.evenement.tel || "-"
                              )}
                              {renderField(
                                "Email",
                                hist.evenement.email || "-"
                              )}
                              {renderField("SMS", hist.evenement.sms || "-")}
                              {renderField(
                                "Date d'échéance",
                                formatDate(hist.evenement.dateEcheance)
                              )}

                              {hist.evenement.bilanDocument && (
                                <div>
                                  <span className="font-medium">
                                    Bilan Document :
                                  </span>{" "}
                                  <a
                                    href={hist.evenement.bilanDocument}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 hover:text-blue-800 underline"
                                  >
                                    Voir document
                                  </a>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    ))}

                  {selectedClient.historiques?.length === 0 && (
                    <p className="text-sm italic text-slate-500">
                      Aucun historique pour l'instant
                    </p>
                  )}
                </div>

                {/* Si aucun évènement Social correspondant */}
                <br />
                {selectedClient.historiques &&
                  selectedClient.historiques.filter(
                    (h) =>
                      h.titre === "création d'évènement" &&
                      h.eventId !== null &&
                      h.evenement?.type === "Social"
                  ).length === 0 && <p>Aucun évènement Social pour ce mois.</p>}

                <br />
              </div>
            )}
          </div>
        </div>
      )}

      <FicheClientOverlay
        client={ficheClientData}
        open={ficheClientOpen}
        loading={ficheClientLoading}
        initialTab="general"
        onClose={() => setFicheClientOpen(false)}
        onClientUpdated={(updated) => {
          ficheClientCache.current[updated.id] = updated;
          setFicheClientData(updated);
        }}
      />
    </div>
  );
}

export default SuiviSocial;
